import React, { useState } from "react";
import TabItem from "components/elements/TabItem";
import PropTypes from "prop-types";
import TabContent from "components/elements/TabContent";
import "./index.scss";

const Tabs = ({ tabList, setFilter }) => {
  const [activeTab, setActiveTab] = useState(tabList[0]?.id);
  return (
    <div className="tabs-container">
      <div className="tab-list">
        {tabList.map((item) => (
          <TabItem
            id={item.id}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            setFilter={setFilter}
            label={item.label}
          />
        ))}
      </div>
      <div className="content-list">
        {tabList.map((item) => (
          <TabContent id={item.id} activeTab={activeTab}>
            {item.content}
          </TabContent>
        ))}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      activeTab: PropTypes.string.isRequired,
      setActiveTab: PropTypes.string.isRequired,
    })
  ).isRequired,
  setFilter: PropTypes.string.isRequired,
};

export default Tabs;
